// Setup › Workforce › Who may direct my agents (COS-MODES): `/c/{slug}/setup/agent-direction`. A
// person's own card: every member opens it (c.$slug.setup.tsx lets this one page past the
// managers' gate); the `agents` add-on (the page shows the add-on banner while it is off).
import { createRoute } from "@tanstack/react-router";
import { AgentDirectionScreen } from "../features/settings/agent-direction";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupAgentDirectionRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "agent-direction",
  component: function SetupAgentDirectionPage() {
    const { api } = setupAgentDirectionRoute.useRouteContext();
    return <AgentDirectionScreen api={api} company={useCompany()} />;
  },
});
